
const schema = {
  MANAGE_OTT: {
    /**
     * manage_ott.read
     */
    READ: 'manage_ott.read',
    /**
     * manage_ott.update
     */
    UPDATE: 'manage_ott.update',
    /**
     * manage_ott.create
     */
    CREATE: 'manage_ott.create',
    /**
     * manage_ott.delete
     */
    DELETE: 'manage_ott.delete',
  },
  MANAGE_ADS: {
    /**
     * manage_ads.read
     */
    READ: 'manage_ads.read',
    /**
     * manage_ads.update
     */
    UPDATE: 'manage_ads.update',
    /**
     * manage_ads.create
     */
    CREATE: 'manage_ads.create',
    /**
     * manage_ads.delete
     */
    DELETE: 'manage_ads.delete',
  },
  MANAGE_CLIENT_CHANNEL_SETTINGS: {
    /**
     * manage_client_channelSettings.read
     */
    READ: 'manage_client_channelSettings.read',
    /**
     * manage_client_channelSettings.update
     */
    UPDATE: 'manage_client_channelSettings.update',
    /**
     * manage_client_channelSettings.create
     */
    CREATE: 'manage_client_channelSettings.create',
    /**
     * manage_client_channelSettings.delete
     */
    DELETE: 'manage_client_channelSettings.delete',
  },
  MANAGE_CLIENT_PLAYER_SETTINGS: {
    /**
     * manage_client_playerSettings.read
     */
    READ: 'manage_client_playerSettings.read',
    /**
     * manage_client_playerSettings.update
     */
    UPDATE: 'manage_client_playerSettings.update',
    /**
     * manage_client_playerSettings.create
     */
    CREATE: 'manage_client_playerSettings.create',
    /**
     * manage_client_playerSettings.delete
     */
    DELETE: 'manage_client_playerSettings.delete',
    /**
     * manage_client_playerSettings.set_default
     */
    SET_DEFAULT: 'manage_client_playerSettings.set_default',
  },
  MANAGE_CLIENT_GLOBAL_MEDIA: {
    /**
     * manage_client_globalMedia.read
     */
    READ: 'manage_client_globalMedia.read',
    /**
     * manage_client_globalMedia.update
     */
    UPDATE: 'manage_client_globalMedia.update',
    /**
     * manage_client_globalMedia.create
     */
    CREATE: 'manage_client_globalMedia.create',
    /**
     * manage_client_globalMedia.delete
     */
    DELETE: 'manage_client_globalMedia.delete',
  },
  MANAGE_CLIENT_LOCATIONS: {
    /**
     * manage_client_locations.read
     */
    READ: 'manage_client_locations.read',
    /**
     * manage_client_locations.update
     */
    UPDATE: 'manage_client_locations.update',
    /**
     * manage_client_locations.create
     */
    CREATE: 'manage_client_locations.create',
    /**
     * manage_client_locations.delete
     */
    DELETE: 'manage_client_locations.delete',
  },
  MANAGE_CLIENT_KEYWORDS: { 
    /**
     * manage_client_keywords.read
     */
    READ: 'manage_client_keywords.read',
    /**
     * manage_client_keywords.update
     */
    UPDATE: 'manage_client_keywords.update',
    /**
     * manage_client_keywords.create
     */
    CREATE: 'manage_client_keywords.create',
    /**
     * manage_client_keywords.delete
     */
    DELETE: 'manage_client_keywords.delete',
  },
  MANAGE_CLIENT_CATEGORIES: {
    /**
     * manage_client_categories.read
     */
    READ: 'manage_client_categories.read',
    /**
     * manage_client_categories.update
     */
    UPDATE: 'manage_client_categories.update',
    /**
     * manage_client_categories.create
     */
    CREATE: 'manage_client_categories.create',
    /**
     * manage_client_categories.delete
     */
    DELETE: 'manage_client_categories.delete',
  },
  MANAGE_CLIENT_ENCODERS: {
    /**
     * manage_client_encoders.read
     */
    READ: 'manage_client_encoders.read',
    /**
     * manage_client_encoders.update
     */
    UPDATE: 'manage_client_encoders.update',
    /**
     * manage_client_encoders.create
     */
    CREATE: 'manage_client_encoders.create',
    /**
     * manage_client_encoders.delete
     */
    DELETE: 'manage_client_encoders.delete',
  },
  MANAGE_CLIENT_TECHNICIANS: {
    /**
     * manage_client_technicians.read
     */
    READ: 'manage_client_technicians.read',
    /**
     * manage_client_technicians.update
     */
    UPDATE: 'manage_client_technicians.update',
    /**
     * manage_client_technicians.create
     */
    CREATE: 'manage_client_technicians.create',
    /**
     * manage_client_technicians.delete
     */
    DELETE: 'manage_client_technicians.delete',
  },
  AGENDA_ADMIN: {
    /**
     * agenda_admin.read
     */
    READ: 'agenda_admin.read',
    /**
     * agenda_admin.update
     */
    UPDATE: 'agenda_admin.update',
    /**
     * agenda_admin.create
     */
    CREATE: 'agenda_admin.create',
    /**
     * agenda_admin.delete
     */
    DELETE: 'agenda_admin.delete',
  },
  AGENDA_EVENT: {
    /**
     * agenda_event.read
     */
    READ: 'agenda_event.read',
    /**
     * agenda_event.update
     */
    UPDATE: 'agenda_event.update',
    /**
     * agenda_event.create
     */
    CREATE: 'agenda_event.create',
    /**
     * agenda_event.delete
     */
    DELETE: 'agenda_event.delete',
  },
  MINUTES_EDITOR: { //@DEPRECATED - replaced by agenda logger
    /**
     * minutes.read
     */
    READ: 'minutes.read',
    /**
     * minutes.update
     */
    UPDATE: 'minutes.update',
    /**
     * minutes.create
     */
    CREATE: 'minutes.create',
    /**
     * minutes.delete
     */
    DELETE: 'minutes.delete',
  },
  EVENT_IMPORTER: {
    /**
     * event_importer.read
     */
    READ: 'event_importer.read',
  },
  EVENT_VIDEO_EDITOR: {
    /**
     * event_videoEditor.read
     */
    READ: 'event_videoEditor.read',
    /**
     * event_videoEditor.commit
     */
    COMMIT: 'event_videoEditor.commit',
  },
  EVENT_TAB_LOCATION: {
    /**
     * event_tab_location.read
     */
    READ: 'event_tab_location.read',
    /**
     * event_tab_location.update
     */
    UPDATE: 'event_tab_location.update',
  },
  EVENT_TAB_TECHNICIANS: {
    /**
     * event_tab_technicians.read
     */
    READ: 'event_tab_technicians.read',
    /**
     * event_tab_technicians.update
     */
    UPDATE: 'event_tab_technicians.update',
  },
  EVENT_TAB_KEYWORDS: {
    /**
     * event_tab_keywords.read
     */
    READ: 'event_tab_keywords.read',
    /**
     * event_tab_keywords.update
     */
    UPDATE: 'event_tab_keywords.update',
  },
  EVENT_TAB_CATEGORIES: {
    /**
     * event_tab_categories.read
     */
    READ: 'event_tab_categories.read',
    /**
     * event_tab_categories.update
     */
    UPDATE: 'event_tab_categories.update',
  },
  EVENT_TAB_SOCIAL: {
    /**
     * event_tab_social.read
     */
    READ: 'event_tab_social.read',
    /**
     * event_tab_social.update
     */
    UPDATE: 'event_tab_social.update',
    /**
     * event_tab_social.delete
     */
    DELETE: 'event_tab_social.delete',
    /**
     * event_tab_social.create
     */
    CREATE: 'event_tab_social.create',
  },
  EVENT_TAB_TRANSCRIPTION: {
    /**
     * event_tab_transcription.read
     */
    READ: 'event_tab_transcription.read',
    /**
     * event_tab_transcription.update
     */
    UPDATE: 'event_tab_transcription.update',
    /**
     * event_tab_transcription.delete
     */
    DELETE: 'event_tab_transcription.delete',
    /**
     * event_tab_transcription.transcription_useAsDefault
     */
    USE_AS_DEFAULT: 'event_tab_transcription.transcription_useAsDefault',
  },
  EVENT_TAB_AUDIO_DESCRIPTION: {
    /**
     * event_tab_audio_description.read
     */
    READ: 'event_tab_audio_description.read',
  },
  EVENT_TAB_AUTOMATION: {
    /**
     * event_tab_automation.read
     */
    READ: 'event_tab_automation.read',
    /**
     * event_tab_automation.update
     */
    UPDATE: 'event_tab_automation.update',
  },
  EVENT_TAB_GENERAL: {
    /**
     * event_tab_general.read
     */
    READ: 'event_tab_general.read',
    /**
     * event_tab_general.update
     */
    UPDATE: 'event_tab_general.update',
    /**
     * event_tab_general.update_domainRestrictions
     */
    DOMAIN_RESTRICTIONS: 'event_tab_general.update_domainRestrictions',
  },
  EVENT_TAB_PLAYER: {
    /**
     * event_tab_player.read
     */
    READ: 'event_tab_player.read',
    /**
     * event_tab_player.update
     */
    UPDATE: 'event_tab_player.update',
  },
  EVENT_TAB_ASSETS: {
    /**
     * event_tab_assets.read
     */
    READ: 'event_tab_assets.read',
    /**
     * event_tab_assets.update
     */
    UPDATE: 'event_tab_assets.update',
    /**
     * event_tab_assets.delete
     */
    DELETE: 'event_tab_assets.delete',
    /**
     * event_tab_assets.create
     */
    CREATE: 'event_tab_assets.create',
    /**
     * event_tab_assets.asset_publishing
     */
    ASSET_PUBLISHING: 'event_tab_assets.asset_publishing',
    /**
     * event_tab_assets.asset_setThumbnail
     */
    ASSET_SET_THUMBNAIL: 'event_tab_assets.asset_setThumbnail',
    /**
     * event_tab_assets.asset_download
     */
    ASSET_DOWNLOAD: 'event_tab_assets.asset_download',
  },
  EVENT: {
    /**
     * event.read
     */
    READ: 'event.read',
    /**
     * event.update
     */
    UPDATE: 'event.update',
    /**
     * event.create
     */
    CREATE: 'event.create',
    /**
     * event.delete
     */
    DELETE: 'event.delete',
    /**
     * event.record_start
     */
    RECORD_START: 'event.record_start',
    /**
     * event.record_stop
     */
    RECORD_STOP: 'event.record_stop',
    /**
     * event.record_pause
     */
    RECORD_PAUSE: 'event.record_pause',
    /**
     * event.update_sourceEncoder
     */
    UPDATE_SOURCE_ENCODER: 'event.update_sourceEncoder',
    /**
     * event.update_customId
     */
    UPDATE_CUSTOM_ID: 'event.update_customId',
    /**
     * event.update_chat
     */
    UPDATE_CHAT: 'event.update_chat',
    /**
     * event.updateLiveAiCaptions
     */
    UPDATE_LIVE_AI_CAPTIONS: 'event.updateLiveAiCaptions',
  },
  ACCOUNT_MESSAGES: {
    /**
     * account_messages.read
     */
    READ: 'account_messages.read',
  },
  ACCOUNT_SECURITY_GROUPS: {
    /**
     * account_securityGroups.read
     */
    READ: 'account_securityGroups.read',
    /**
     * account_securityGroups.update
     */
    UPDATE: 'account_securityGroups.update',
    /**
     * account_securityGroups.create
     */
    CREATE: 'account_securityGroups.create',
    /**
     * account_securityGroups.delete
     */
    DELETE: 'account_securityGroups.delete',
  },
  ACCOUNT_CONTENT_GROUPS: {
    /**
     * account_contentGroups.read
     */
    READ: 'account_contentGroups.read',
    /**
     * account_contentGroups.update
     */
    UPDATE: 'account_contentGroups.update',
    /**
     * account_contentGroups.create
     */
    CREATE: 'account_contentGroups.create',
    /**
     * account_contentGroups.delete
     */
    DELETE: 'account_contentGroups.delete',
  },
  /** ACCOUNT */
  ACCOUNT: {
    /**
     * account.read
     */
    READ: 'account.read',
    /**
     * account.read_api
     */
    READ_API: 'account.read_api',
    /**
     * account.read_billing
     */
    READ_BILLING: 'account.read_billing',
    /**
     * account.any_update
     */
    ANY_UPDATE: 'account.any_update',
    /**
     * account.any_resetPassword
     */
    ANY_RESET_PASSWORD: 'account.any_resetPassword',
    /**
     * account.any_create
     */
    ANY_CREATE: 'account.any_create',
    /**
     * account.any_delete
     */
    ANY_DELETE: 'account.any_delete',
  },
  ANALYTICS: {
    /**
     * analytics.read
     */
    READ: 'analytics.read',
    /**
     * analytics.export
     */
    EXPORT: 'analytics.export',
  }
}

export default schema